// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3rrAG","buttons":"SendReceipts_buttons__1fYrc","email":"SendReceipts_email__2pMtD","bookApptTitle":"SendReceipts_bookApptTitle__2VWN9"};